(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    // Get all swatches (color and size)
    document.querySelectorAll('.custom_swatch .ps_swatchs input').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const hiddenInput = document.querySelector('#contactTags');

        if (!hiddenInput) {
          console.warn('Hidden input #contactTags not found!');
          return;
        }

        // Collect selected values
        const sizeInput = document.querySelector('.title_Size .ps_swatchs input:checked');
        const colorInput = document.querySelector('.title_Color .ps_swatchs input:checked');

        const selectedSize = sizeInput ? sizeInput.value : '';
        const selectedColor = colorInput ? colorInput.value : '';

        const newvalue = hiddenInput.getAttribute('newvalue') || '';
        const colorvalue = hiddenInput.getAttribute('colorvalue') || '';

        // Final value to assign
        const finalValue = 'newsletter,' + newvalue + '_' + selectedSize + '/' + selectedColor + ',newsletter_wishlist';
        hiddenInput.setAttribute('value', finalValue);

        console.log('Updated #contactTags value:', finalValue);
      });
    });

    // Log initial checked value (optional)
    const initialCheck = document.querySelector('.custom_swatch .ps_swatchs input:checked');
    if (initialCheck) {
      console.log('Initially selected value:', initialCheck.value);
    }
  }, 2000);
});
  } catch(e) { console.error(e); }
})();

})();
